import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import axios from 'axios'

import { Stack, Paper, Box, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material'
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from "react-router-dom";

export default function SupportUs(props) {

    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isSupporter, setIsSupporter] = useState(false);
    const [supporterStatusExpDateLocal, setSupporterStatusExpDateLocal] = useState();
    const [token, setToken] = useState("");

    const apiPath = '/api/NACHUsers/GetMySupporterStatusExpDateUtc';

    useEffect(async () => {
        var isLoggedIn = await authService.isAuthenticated();
        if (isLoggedIn) {
            var tk1 = await authService.getAccessToken();
            await setToken(tk1);
            setAuthenticated(isLoggedIn);
            //var user = await authService.getUser();
            await GetMySupporterStatusExpDateUtc(tk1);
        }
    }, []);

    const GetMySupporterStatusExpDateUtc = async (token) => {
        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }

        axios.get(apiPath, headers).then((response) => {
            setIsSupporter(response.data.isSupporter);
            var utcDate = response.data.supporterStatusExpDateUtc + 'Z'
            var localDate = new Date(utcDate);
            setSupporterStatusExpDateLocal(localDate)
            
}).catch((error) => {
            console.log(JSON.stringify(error));
        });
    };



//https://mui.com/material-ui/customization/palette/#adding-new-colors

    return (
        <Box my={2}>
            <Paper my={2} elevation={3}>
                <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={false}>
                    <AccordionSummary aria-controls="player-info" id="player-info" expandIcon={<ExpandMoreIcon />} sx={{backgroundColor: isSupporter ? '#4caf50' : '#9c27b0'}}>
                        <Typography color='white'>{isSupporter ? 'Thank you for your support to MetaDB!' + ' [Your support will expire on '+supporterStatusExpDateLocal +']': 'Support MetaDB [If you are a supporter and still see this purple bar, try log out and log back in!]'}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {!isSupporter &&
                            <div>
                                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                                    <Typography color='primary'>By donating $50/year, supporters will get following benefits - </Typography>
                                </Stack>
                                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                                    <Typography color='primary' component="div">
                                        <ul>
                                            <li>Download 12 PGN's every 24 hours</li>
                                            <ul>
                                                <li>Non-supporters can only download 1 PGN every 24 hours</li>
                                            </ul>
                                            <li>Access newest games in MetaDB</li>
                                            <ul>
                                                <li>New games are being added to MetaDB every day</li>
                                                <li>Supporters can download or view newest games once they are in MetaDB</li>
                                                <li>Non-supporters can not download or view games of current year [{new Date().getFullYear()}] and the year before [{new Date().getFullYear()-1}]</li>
                                            </ul>
                                            <li>Protection of PGN and Games</li>
                                            <ul>
                                                <li>Non-supporters can not download PGN of supporters</li>
                                                <li>Non-supporters can not view games of supporters</li>
                                                <li>Only supporters can view/download other supporters' games</li>
                                            </ul>
                                            <li>Supporter-only features</li>
                                            <ul>
                                                <li>Filter blitz games from PGN</li>
                                                <li>Search games with similar names</li>
                                                <li>Notification of PGN being downloaded</li>
                                                <li>Download online games from Chess.com and Lichess.org</li>
                                            </ul>
                                        </ul>
                                    </Typography>
                                </Stack>
                                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                                    <Link to="/SupporterDonate">
                                        <Button variant='contained'>Donate $50 and become a MetaDB Supporter</Button>
                                    </Link>
                                </Stack>
                            </div>
                        }
                        {isSupporter &&
                            <div>
                                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                                    <Typography color='primary'>{'Thank you for your support to MetaDB! Your supporter status will expire on '+supporterStatusExpDateLocal}</Typography>
                                </Stack>
                                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                                    <Typography color='primary'>Enjoy the following benefits as a MetaDB supporter -</Typography>
                                </Stack>
                                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                                    <Typography color='primary' component="div">
                                        <ul>
                                            <li>Download 12 PGN's every 24 hours (Starting Jan 1st 2026, it will be 4 PGN's very 12 hours)</li>
                                            <ul>
                                                <li>Non-supporters can only download 1 PGN every 24 hours</li>
                                            </ul>
                                            <li>Access newest games in MetaDB</li>
                                            <ul>
                                                <li>New games are being added to MetaDB every hour</li>
                                                <li>Supporters can download or view newest games once they are in MetaDB</li>
                                                <li>Non-supporters can not download or view games of current year [{new Date().getFullYear()}] and the year before [{new Date().getFullYear()-1}]</li>
                                            </ul>
                                            <li>Protection of PGN and Games</li>
                                            <ul>
                                                <li>Non-supporters can not download PGN of supporters</li>
                                                <li>Non-supporters can not view games of supporters</li>
                                                <li>Only supporters can view/download other supporters' games</li>
                                            </ul>
                                            <li>Supporter-only features</li>
                                            <ul>
                                                <li>Filter blitz games from PGN</li>
                                                <li>Search games with similar names</li>
                                                <li>Notification of PGN being downloaded</li>
                                                <li>Download online games from Chess.com and Lichess.org</li>
                                            </ul>
                                        </ul>
                                    </Typography>
                                </Stack>
                                <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                                    <Link to="/Tools">
                                        <Button variant='contained'>Go to Tools</Button>
                                    </Link>
                                    <Link to="/SupporterDonate">
                                        <Button variant='contained'>Donate $65 to extend another year of support</Button>
                                    </Link>
                                </Stack>
                            </div>
                        }
                    </AccordionDetails>
                </Accordion>
            </Paper>
        </Box>
    )
}

